/**
 * Styles der Default-Komponenten. Alles unter `.ch-root`, nur ueber
 * CSS-Variablen — der Host setzt sie (oder erbt Schrift und Farbe), die
 * Fallbacks sind neutral genug fuer jeden Admin.
 */
export const STYLES = `
.ch-root {
  font-family: var(--ch-font, inherit);
  color: var(--ch-fg, inherit);
  background: var(--ch-bg, transparent);
  line-height: 1.5;
}
.ch-root .ch-muted { color: var(--ch-muted, #6b6b66); }
.ch-root .ch-hinweis {
  color: var(--ch-warn, #8a5a00);
  background: color-mix(in srgb, var(--ch-warn, #8a5a00) 8%, transparent);
  border-radius: var(--ch-radius, 8px);
  padding: 6px 10px;
  margin: 6px 0;
}
.ch-root .ch-tabs, .ch-root .ch-filter { display: flex; flex-wrap: wrap; gap: 6px; margin: 0 0 14px; }
.ch-root .ch-tab, .ch-root .ch-chip, .ch-root .ch-knopf {
  font: inherit;
  color: inherit;
  background: transparent;
  border: 1px solid var(--ch-border, color-mix(in srgb, currentColor 20%, transparent));
  border-radius: var(--ch-radius, 8px);
  padding: 5px 12px;
  cursor: pointer;
}
.ch-root .ch-tab-aktiv, .ch-root .ch-chip-aktiv {
  border-color: var(--ch-accent, #2f6fdb);
  color: var(--ch-accent, #2f6fdb);
  font-weight: 600;
}
.ch-root .ch-zahl { opacity: .7; font-weight: 400; }
.ch-root .ch-knopf-primaer {
  background: var(--ch-accent, #2f6fdb);
  border-color: var(--ch-accent, #2f6fdb);
  color: var(--ch-on-accent, #fff);
}
.ch-root .ch-knopf:disabled { opacity: .5; cursor: default; }
.ch-root .ch-intro { margin: 0 0 12px; }
.ch-root .ch-karten { list-style: none; padding: 0; margin: 0; display: grid; gap: 12px; }
.ch-root .ch-karte {
  border: 1px solid var(--ch-border, color-mix(in srgb, currentColor 15%, transparent));
  border-radius: var(--ch-radius, 8px);
  padding: 14px 16px;
}
/* Schriftstaerke und Nummerierung ausdruecklich setzen: Resets wie Tailwinds
   Preflight nehmen Ueberschriften das Fett und Listen die Zaehlung (2N-Admin). */
.ch-root .ch-titel { font-size: 1.05em; font-weight: 600; line-height: 1.3; margin: 0 0 6px; }
.ch-root .ch-text { margin: 0 0 8px; }
.ch-root .ch-drehplan { margin: 0 0 8px; padding-left: 20px; list-style: decimal outside; }
.ch-root .ch-drehplan li { display: list-item; margin-bottom: 4px; }
.ch-root strong { font-weight: 600; }
.ch-root .ch-bild { display: block; }
.ch-root .ch-sprech { display: block; font-style: italic; }
.ch-root .ch-braucht, .ch-root .ch-vorlage { margin: 6px 0; font-size: .92em; }
.ch-root .ch-vorlage a, .ch-root .ch-muted a { color: var(--ch-accent, #2f6fdb); }
.ch-root .ch-aktionen { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; align-items: center; }
.ch-root .ch-telegram { border: 1px solid var(--ch-border, #ddd); border-radius: var(--ch-radius, 8px); padding: 12px; margin: 8px 0 12px; }
.ch-root .ch-telegram .ch-text { margin: 0 0 8px; }
.ch-root .ch-telegram-liste { list-style: none; padding: 0; margin: 0 0 8px; }
.ch-root .ch-telegram a.ch-knopf { display: inline-block; text-decoration: none; }
.ch-root .ch-kopf { display: flex; justify-content: space-between; align-items: baseline; gap: 8px; flex-wrap: wrap; }
.ch-root .ch-klein { font-size: .8em; }
.ch-root .ch-link {
  background: none; border: 0; padding: 0; font: inherit; text-align: left;
  color: var(--ch-accent, #2f6fdb); cursor: pointer;
}
.ch-root .ch-raster {
  list-style: none; padding: 0; margin: 0;
  display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 16px;
}
.ch-root .ch-kachel {
  display: flex; flex-direction: column; gap: 4px;
  border: 1px solid var(--ch-border, color-mix(in srgb, currentColor 15%, transparent));
  border-radius: var(--ch-radius, 8px);
  padding: 10px;
}
.ch-root .ch-kachel .ch-titel { margin: 6px 0 0; }
.ch-root .ch-kachel .ch-aktionen { margin-top: 6px; }
.ch-root .ch-player {
  position: relative; width: 100%; aspect-ratio: 9 / 16; overflow: hidden;
  border-radius: calc(var(--ch-radius, 8px) - 2px); background: #111;
}
.ch-root .ch-player iframe { position: absolute; inset: 0; width: 100%; height: 100%; border: 0; }
.ch-root .ch-player-leer {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 10px; padding: 14px; text-align: center; color: #eee;
}
.ch-root .ch-player-leer .ch-klein { opacity: .75; }
.ch-root .ch-zahlen { margin: 0; font-size: .92em; }
.ch-root .ch-faktor {
  display: inline-block; margin-left: 6px; padding: 0 7px; border-radius: 999px; font-weight: 600;
  background: color-mix(in srgb, var(--ch-accent, #2f6fdb) 14%, transparent);
  color: var(--ch-accent, #2f6fdb);
}
.ch-root .ch-details { margin-top: 4px; }
.ch-root .ch-upload {
  display: flex; flex-wrap: wrap; align-items: center; gap: 10px;
  padding: 14px; margin: 0 0 14px;
  border: 1px dashed var(--ch-border, color-mix(in srgb, currentColor 25%, transparent));
  border-radius: var(--ch-radius, 8px);
}
.ch-root .ch-upload-aktiv {
  border-color: var(--ch-accent, #2f6fdb);
  background: color-mix(in srgb, var(--ch-accent, #2f6fdb) 6%, transparent);
}
.ch-root .ch-uploads { list-style: none; padding: 0; margin: 0 0 14px; display: grid; gap: 8px; }
.ch-root .ch-balken { height: 4px; border-radius: 2px; overflow: hidden; background: color-mix(in srgb, currentColor 12%, transparent); }
.ch-root .ch-balken > span { display: block; height: 100%; background: var(--ch-accent, #2f6fdb); }
.ch-root .ch-warn-text { color: var(--ch-warn, #8a5a00); }
.ch-root .ch-medium-bild {
  position: relative; aspect-ratio: 1 / 1; overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  border-radius: calc(var(--ch-radius, 8px) - 2px);
  background: color-mix(in srgb, currentColor 8%, transparent);
}
.ch-root .ch-medium-bild img { width: 100%; height: 100%; object-fit: cover; display: block; }
.ch-root .ch-marke {
  position: absolute; left: 6px; top: 6px; padding: 1px 7px; border-radius: 999px;
  font-size: .75em; background: rgba(0, 0, 0, .6); color: #fff;
}
.ch-root .ch-plakette {
  display: inline-block; margin-right: 4px; padding: 0 7px; border-radius: 999px; font-size: .8em;
  border: 1px solid var(--ch-border, color-mix(in srgb, currentColor 20%, transparent));
}
.ch-root .ch-plakette-ok { border-color: var(--ch-accent, #2f6fdb); color: var(--ch-accent, #2f6fdb); }
.ch-root .ch-plakette-warn { border-color: var(--ch-warn, #8a5a00); color: var(--ch-warn, #8a5a00); }
.ch-root .ch-plan { margin: 0 0 24px; }
.ch-root .ch-woche { margin: 18px 0 8px; font-weight: 600; }
.ch-root .ch-post-medien { display: flex; gap: 6px; overflow-x: auto; margin: 8px 0; }
.ch-root .ch-post-medien a { flex: 0 0 auto; display: flex; align-items: center; justify-content: center;
  width: 76px; height: 76px; border-radius: calc(var(--ch-radius, 8px) - 2px); overflow: hidden;
  background: color-mix(in srgb, currentColor 8%, transparent); }
.ch-root .ch-post-medien img { width: 100%; height: 100%; object-fit: cover; display: block; }
/* Kalender (ab 0.15.0): Medien fuer einen eigenen Beitrag waehlen */
.ch-root .ch-medienwahl { flex-wrap: wrap; overflow: visible; }
.ch-root .ch-medienwahl button { position: relative; flex: 0 0 auto; width: 76px; height: 76px; padding: 0;
  border: 2px solid transparent; border-radius: calc(var(--ch-radius, 8px) - 2px); overflow: hidden; cursor: pointer;
  background: color-mix(in srgb, currentColor 8%, transparent); color: inherit; font: inherit; }
.ch-root .ch-medienwahl button.ch-gewaehlt { border-color: var(--ch-accent, #2f6fdb); }
.ch-root .ch-medienwahl img { width: 100%; height: 100%; object-fit: cover; display: block; }
.ch-root .ch-nummer { position: absolute; top: 3px; left: 3px; min-width: 18px; height: 18px; border-radius: 9px;
  background: var(--ch-accent, #2f6fdb); color: var(--ch-on-accent, #fff); font-size: 11px; font-weight: 700;
  display: grid; place-items: center; }
.ch-root .ch-kalender > .ch-kopf { margin-bottom: 8px; }
.ch-root .ch-feld {
  font: inherit; width: 100%; box-sizing: border-box; min-height: 90px; margin: 2px 0 8px;
  padding: 6px 10px; resize: vertical; color: inherit; background: transparent;
  border: 1px solid var(--ch-border, color-mix(in srgb, currentColor 20%, transparent));
  border-radius: var(--ch-radius, 8px);
}
.ch-root .ch-karte .ch-eingabe { display: block; width: 100%; box-sizing: border-box; margin: 2px 0 8px; }
.ch-root .ch-eingabe {
  font: inherit;
  flex: 1 1 240px;
  min-width: 0;
  padding: 5px 10px;
  border: 1px solid var(--ch-border, color-mix(in srgb, currentColor 20%, transparent));
  border-radius: var(--ch-radius, 8px);
  background: transparent;
  color: inherit;
}
/* Newsletter (ab 0.7.0) */
.ch-root .ch-nl-vorschau {
  display: grid; gap: 8px; margin: 10px 0; padding: 12px;
  border-radius: var(--ch-radius, 8px);
  background: color-mix(in srgb, currentColor 4%, transparent);
}
.ch-root .ch-nl-block .ch-text:last-child { margin-bottom: 0; }
.ch-root .ch-nl-rahmen {
  display: flex; flex-direction: column; gap: 2px; padding: 10px 12px;
  border: 1px solid var(--ch-border, color-mix(in srgb, currentColor 15%, transparent));
  border-radius: var(--ch-radius, 8px);
}
.ch-root .ch-nl-rahmen a { color: var(--ch-accent, #2f6fdb); }
.ch-root .ch-formular label { display: block; }
.ch-root .ch-formular select.ch-eingabe { display: block; width: 100%; box-sizing: border-box; margin: 2px 0 8px; }
.ch-root .ch-auswahl { display: flex; flex-wrap: wrap; gap: 6px 16px; margin: 2px 0 10px; }
.ch-root .ch-auswahl label { display: flex; align-items: center; gap: 6px; }
/* Newsletter der Website (ab 0.8.0) */
.ch-root .ch-nl-mail { display: block; width: 100%; height: 640px; margin: 10px 0; background: #fff;
  border: 1px solid var(--ch-border, color-mix(in srgb, currentColor 15%, transparent));
  border-radius: var(--ch-radius, 8px); }
.ch-root .ch-nl-test { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 8px; margin: 6px 0; }
.ch-root .ch-nl-test .ch-eingabe { flex: 1 1 220px; margin: 0; }
.ch-root .ch-nl-zahlen { margin: 6px 0; }
.ch-root .ch-nl-zahlen p { margin: 0 0 4px; }
.ch-root .ch-nl-zahlen summary { cursor: pointer; color: var(--ch-muted, #6b6b66); }
.ch-root .ch-nl-links { list-style: none; margin: 6px 0; padding: 0; }
.ch-root .ch-nl-links li { display: flex; justify-content: space-between; gap: 12px; padding: 2px 0; border-bottom: 1px solid var(--ch-border, color-mix(in srgb, currentColor 12%, transparent)); }
.ch-root .ch-nl-links a { color: var(--ch-accent, #2f6fdb); overflow-wrap: anywhere; }
.ch-root .ch-tabelle { width: 100%; border-collapse: collapse; margin: 8px 0; }
.ch-root .ch-tabelle th, .ch-root .ch-tabelle td { text-align: left; padding: 6px 8px; vertical-align: top;
  border-bottom: 1px solid var(--ch-border, color-mix(in srgb, currentColor 12%, transparent)); }
.ch-root .ch-tabelle th { font-weight: 600; font-size: .9em; }
/* Melden (ab 0.12.0). Der Dialog liegt bewusst hoch: In einem Admin mit eigener
   Kopfzeile und eigenen Dialogen ist alles darunter irgendwann verdeckt. */
.ch-ticket-hintergrund {
  position: fixed; inset: 0; z-index: 9000;
  display: flex; align-items: center; justify-content: center;
  padding: 16px; background: rgba(0, 0, 0, .45);
}
.ch-ticket-dialog {
  width: 100%; max-width: 560px; max-height: 90vh; overflow: auto;
  box-sizing: border-box; padding: 18px 20px;
  font-family: var(--ch-font, inherit);
  color: var(--ch-fg, inherit);
  background: var(--ch-bg, #fff);
  border: 1px solid var(--ch-border, color-mix(in srgb, currentColor 20%, transparent));
  border-radius: var(--ch-radius, 8px);
}
.ch-ticket-dialog p { margin: 0 0 12px; }
.ch-ticket-feld { display: block; margin: 0 0 12px; }
.ch-ticket-feld > span { display: block; margin-bottom: 4px; font-size: .9em; }
.ch-ticket-feld .ch-eingabe { display: block; width: 100%; box-sizing: border-box; flex: none; }
.ch-ticket-zeile { display: flex; justify-content: flex-end; gap: 8px; margin-top: 4px; }
.ch-ticket-kontext { margin: 0 0 12px; }
.ch-ticket-aufklappen {
  font: inherit; font-size: .9em; color: var(--ch-muted, #6b6b66);
  background: none; border: 0; padding: 0; cursor: pointer; text-decoration: underline;
}
.ch-ticket-liste { margin-top: 6px; font-size: .85em; overflow-wrap: anywhere; }
.ch-ticket-liste > div { padding: 1px 0; }
/* Meine Meldungen (ab 0.13.0) */
.ch-root .ch-ticket-kopf { margin: 0 0 12px; }
.ch-root .ch-ticket-titel {
  display: flex; align-items: baseline; justify-content: space-between; gap: 12px;
  font-weight: 600; margin-bottom: 4px;
}
.ch-root .ch-ticket-stand {
  flex: none; font-size: .8em; font-weight: 400; white-space: nowrap;
  padding: 2px 8px; border-radius: 999px;
  border: 1px solid var(--ch-border, color-mix(in srgb, currentColor 20%, transparent));
}
/* Nur der eine Stand faellt ins Auge: Dort liegt etwas fuer den Kunden bereit. */
.ch-root .ch-stand-zum_pruefen {
  border-color: var(--ch-accent, #2f6fdb);
  color: var(--ch-accent, #2f6fdb);
}
.ch-root .ch-stand-abgeschlossen { opacity: .65; }
.ch-root .ch-ticket-wann { font-size: .85em; margin-top: 4px; }
.ch-root .ch-ausschluesse { border: 1px solid var(--ch-border, #ddd); border-radius: var(--ch-radius, 8px); padding: 12px; margin: 8px 0 12px; }
.ch-root .ch-ausschluesse textarea.ch-eingabe { display: block; width: 100%; box-sizing: border-box; min-height: 64px; margin: 6px 0 8px; font: inherit; }
.ch-root .ch-vorschlaege-kopf { display: flex; flex-wrap: wrap; gap: 8px 12px; align-items: center; margin: 4px 0 12px; }
.ch-root .ch-vorschlag { list-style: none; border: 1px solid var(--ch-border, #ddd); border-radius: var(--ch-radius, 8px); padding: 12px; }
.ch-root .ch-vorschlag .ch-format { display: inline-block; font-size: .8em; padding: 1px 8px; border-radius: 999px; border: 1px solid var(--ch-border, #ddd); color: var(--ch-muted, #666); margin-bottom: 6px; }
.ch-root .ch-transkript { white-space: pre-wrap; margin: 4px 0 8px; padding: 8px 10px; border-left: 3px solid var(--ch-accent, #2f6fdb); background: color-mix(in srgb, var(--ch-accent, #2f6fdb) 6%, transparent); }
.ch-root .ch-liste-vorschlaege { display: grid; gap: 12px; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); padding: 0; margin: 0; }
`;
